/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetBoxesService,
  IGetBoxesMethods,
  CreateOrderService,
  ICreateOrderTypeMethods,
  IGetInvoicePdfTypeMethods,
  GetInvoicePdfService,
  UpdateDelegateNameService,
  IUpdateDelegateNameMethods,
  IGetBoxesYearMethods,
  GetBoxesYearService,
  IGetPastPurchaseBoxesMethods,
  GetPastPurchaseBoxesService,
  ICreatePayFACMethods,
  CreatePayFACService,
  IValidateDiscountMethods,
  ValidateDiscountService,
  BrandDetailsService,
  IBrandDetailsMethods,
  IGetCitiesMethods,
  GetCitiesService,
  IUpdateBoxMethods,
  UpdateBoxService,
  IGetMyDiscountMethods,
  GetMyDiscountService
} from "./components";

export type PurchasedCostumePageAgent = IStaticPageContentMethods &
  IGetBoxesMethods &
  ICreateOrderTypeMethods &
  IUpdateDelegateNameMethods &
  IGetBoxesYearMethods &
  ICreatePayFACMethods &
  IUpdateBoxMethods &
  IGetCitiesMethods &
  IGetInvoicePdfTypeMethods &
  IValidateDiscountMethods &
  IGetPastPurchaseBoxesMethods &
  IGetMyDiscountMethods &
  IBrandDetailsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetBoxesService(),
    new CreateOrderService(),
    new GetInvoicePdfService(),
    new UpdateDelegateNameService(),
    new GetBoxesYearService(),
    new GetPastPurchaseBoxesService(),
    new UpdateBoxService(),
    new GetCitiesService(),
    new GetMyDiscountService(),
    new CreatePayFACService(),
    new ValidateDiscountService(),
    new BrandDetailsService(),
  ];
};

export const getAgent = () => {
  return createAgent<PurchasedCostumePageAgent>({
    plugins: getPlugins(),
  });
};
